import { render, staticRenderFns } from "./iamStudy.vue?vue&type=template&id=808e82f4&scoped=true&"
import script from "./iamStudy.vue?vue&type=script&lang=js&"
export * from "./iamStudy.vue?vue&type=script&lang=js&"
import style0 from "./iamStudy.vue?vue&type=style&index=0&id=808e82f4&scoped=true&lang=css&"
import style1 from "./iamStudy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808e82f4",
  null
  
)

export default component.exports